import { createFileRoute } from '@tanstack/react-router'
import Footer from '../components/landing/Footer'
import "./legal.css"

export const Route = createFileRoute('/support')({
  component: SupportPage,
})

function SupportPage() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1 className="legal-title">Support & Services</h1>
        
        <div className="legal-intro">
          <p>
            The Modulus Sell platform expands beyond physical goods to accommodate service-based businesses, 
            entertainment zones, and dining establishments, offering specialized support infrastructure.
          </p>
        </div>

        <div className="legal-section">
          <h2>We're Here to Help</h2>
          <p>
            Whether you need assistance with setting up your inventory, managing your billing, or launching your online store, our dedicated support team is ready to assist you.
          </p>
        </div>

        <div className="legal-section">
          <h2>Contact Support</h2>
          <p>Need assistance with your account or having trouble with the app? Our team is here to help.</p>
          <p>
            <strong>Email:</strong> <a href="mailto:sarfarazahmedkl@modulusseventeen.com">sarfarazahmedkl@modulusseventeen.com</a><br/>
            <strong>Phone:</strong> <a href="tel:+918078227271">+91 8078 227 271</a><br/>
            <strong>Support Hours:</strong> Available Daily
          </p>
        </div>
      </div>
      <Footer />
    </div>
  )
}
